import { render } from "./AccessibilitySwitch.vue?vue&type=template&id=0cbd0182"
import script from "./AccessibilitySwitch.vue?vue&type=script&lang=js"
export * from "./AccessibilitySwitch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__